export var getters = {
    getCompany: function (state) { return function (companyId) { return state.companies.find(function (c) { return c.id === companyId; }); }; },
};
